var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from "react";
import BindToChainState from "../Utility/BindToChainState";
import ChainTypes from "../Utility/ChainTypes";
import Immutable from "immutable";

var BalanceWrapper = function (_React$Component) {
    _inherits(BalanceWrapper, _React$Component);

    function BalanceWrapper() {
        _classCallCheck(this, BalanceWrapper);

        return _possibleConstructorReturn(this, (BalanceWrapper.__proto__ || Object.getPrototypeOf(BalanceWrapper)).apply(this, arguments));
    }

    _createClass(BalanceWrapper, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                wrap = _props.wrap,
                orders = _props.orders,
                others = _objectWithoutProperties(_props, ["wrap", "orders"]);

            var balanceAssets = this.props.balances.filter(function (b) {
                return !!b && b.get("balance") !== 0;
            }).map(function (b) {
                return b.get("asset_type");
            });

            var ordersByAsset = orders.filter(function (o) {
                return !!o;
            }).reduce(function (orders, o) {
                var asset_id = o.getIn(["sell_price", "base", "asset_id"]);
                if (!orders[asset_id]) orders[asset_id] = 0;
                orders[asset_id] += parseInt(o.get("for_sale"), 10);
                return orders;
            }, {});

            for (var id in ordersByAsset) {
                if (balanceAssets.indexOf(id) === -1) {
                    balanceAssets.push(id);
                }
            }

            var Component = wrap;
            return React.createElement(Component, _extends({}, others, {
                orders: ordersByAsset,
                balanceAssets: Immutable.List(balanceAssets)
            }));
        }
    }]);

    return BalanceWrapper;
}(React.Component);

BalanceWrapper.propTypes = {
    balances: ChainTypes.ChainObjectsList,
    orders: ChainTypes.ChainObjectsList
};
BalanceWrapper.defaultProps = {
    balances: Immutable.List(),
    orders: Immutable.List()
};


export default BindToChainState(BalanceWrapper);